import http from "./http";

let qs = require("qs");

function getChats(params) {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const application = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().application
    : "";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .get(`${api}/chats`, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
        params: {
          ...params,
        },
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: "repeat" }),
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function putChat(chatId, chat) {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const application = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().application
    : "";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .put(`${api}/chats/${chatId}`, chat, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

function archiveChat(chatId) {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const application = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().application
    : "";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .put(`${api}/chats/${chatId}/archive`, null, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

function getChatMessages(chatId, params) {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const application = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().application
    : "";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .get(`${api}/chats/${chatId}/messages`, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
        params: {
          ...params,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

function viewMessage(chatId, messageId) {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const application = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().application
    : "";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .put(`${api}/chats/${chatId}/messages/${messageId}/viewed`, null, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

function viewChat(chatId) {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const application = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().application
    : "";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .put(`${api}/chats/${chatId}/messages/viewed`, null, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

export default {
  getChats,
  putChat,
  archiveChat,
  getChatMessages,
  viewMessage,
  viewChat,
};
